var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowledge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E8ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 16C25 17.5 24.5 19.5 22.1 20.3C22.8 18.6 22.9 16.9 22.4 15.3C21.7 13.2 19.4 11.6 17.8 10.7C17.4 10.4 16.7 10.8 16.8 11.4C16.8 12.5 16.5 14.1 14.8 15.8C12.6 18 11.5 20.3 11.5 22.5C11.5 25.4 13.5 29 17.5 29C13.5 25 16.5 21.5 16.5 21.5C17.3 27.4 21.5 29 23.5 29C25.2 29 28.5 27.8 28.5 22.6C28.5 19.5 27.2 17.1 26.1 15.7C25.8 15.2 25.1 15.5 25 16Z",
    fill: "#EFA9AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledge);
export default __webpack_public_path__ + "static/media/knowledge.9a3cec549bad85acada839f32bda1fcb.svg";
export { ForwardRef as ReactComponent };